export default __webpack_public_path__ + "static/media/AL_DIA_TX.24cc8baf.png";